import Config from '../lib/config'
import signalr from 'react-native-signalr'
import getNetInfo from './shim/netInfo'

class WS{
	connection		= null
	proxy			= null
	connected 		= false
	listeners 		= {}
	timer 			= false

	storedEvents 	= {}

	constructor(){
		this.connection = signalr.hubConnection(Config.WEBSOCKET_ENDPOINT)

		if(__DEV__){
			this.connection.logging = true
		}

		this.proxy = this.connection.createHubProxy('ClientAppHub')

		this.connection.reconnecting(this.reconnecting.bind(this))
		this.connection.reconnected(this.reconnected.bind(this))
		this.connection.disconnected(this.disconnected.bind(this))
		this.connection.connectionSlow(this.connectionSlow.bind(this))
		this.connection.error(this.error.bind(this))

		// Store all events or call the listener
		this.proxy.on('eventStatusChanged', (event) => {
			if(!(event instanceof Object)){
				event = JSON.parse(event)
			}

			console.log('WebsocketEvent:', JSON.stringify(event))

			if(event.EventId in this.listeners){
				this.listeners[event.EventId](event)
			}else{
				this.storedEvents[event.EventId] = event
			}
		})
	}

	_start(resume=true){
		console.log("WS: Connecting")
		return this.connection.start({transport: 'webSockets'}).then(() => {
			this.connected = true

			if(resume){
				const eventIds = Object.keys(this.listeners)
				if(eventIds.length > 0){
					this._invoke('SubscribeToEvents', eventIds)
				}
			}
		})
	}

	_stop(){
		if(!this.timer){
			this.timer = setTimeout(() => {
				if(!this._hasListeners()){
					console.log("WS: Stopping")
					this.connection.stop()
					this.connected = false
				}
			}, 60000)
		}
	}

	updated(message){
		console.log('WS:', message)
	}

	error(error){
		console.log('WS Error: ' + error)
	}

	connectionSlow(){
		console.log('WS:', 'connection slow')
	}

	reconnecting(){
		console.log('WS:', 'reconnecting')
	}

	reconnected(){
		console.log('WS:', 'reconnected')
	}

	disconnected(){
		this.connected = false

		// signalR will try to keep the websocket alive, but if the connection dies before they have set up the polling disconnection, this gets called
		if(this._hasListeners()){
			console.log('WS:', 'disconnected but still have listeners, try to connect once internet is on')

			try{
				const NetInfo = getNetInfo()
				NetInfo.isConnected.fetch().then((isConnected) => {
					if(isConnected){
						// Server error maybe, so try again in 20seconds
						setTimeout(this._start.bind(this), 20000)
					}else{
						// Device has gone offline, lets wait until they connect again
						const callback = (isConnected) => {
							if(isConnected){
								this._start()
								NetInfo.isConnected.removeEventListener('change', callback)
							}
						}

						NetInfo.isConnected.addEventListener('change', callback)
					}
				})
			}catch(e){
				console.log(e)
			}
		}

		console.log('WS:', 'disconnected')
	}

	waitFor(eventId, timeout){
		if(eventId in this.storedEvents){
			return Promise.resolve(this.storedEvents[eventId])
		}else{
			return this._addListener(eventId, timeout).then((event) => {
				this._removeListener(eventId)

				return event
			}).catch((e) => {
				this._removeListener(eventId)
				throw e
			})
		}
	}

	_addListener(eventId, timeout){
		clearTimeout(this.timer)

		return new Promise((accept, reject) => {

			const timeoutInstance = setTimeout(() => {
				const timeoutError = new Error("listener timeout")
				timeoutError.code = "listener timeout"
				reject(timeoutError)
			}, timeout || 10000)

			this.listeners[eventId] = (event) => {
				clearTimeout(timeoutInstance)
				if(event.Status !== 'Error'){
					accept(event)
				}else{
					const error = new Error(event.reason)
					error.event = event
					error.code = event.reason
					reject(error)
				}
			}

			this._invoke('SubscribeToEvent', eventId)
		})
	}

	_removeListener(eventId){
		delete this.listeners[eventId]
		this._invoke('UnsubscribeFromEvent', eventId)
	}

	_invoke(event, ...args){
		console.log(`WS: _invoke ${event}`, args)
		if(event === 'SubscribeToEvent' && !this.connected){
			this._start(false).then(() => {
				this.proxy.invoke(event, ...args)
			})

		}else if(event === 'UnsubscribeFromEvent' && this.connected){
			this.proxy.invoke(event, ...args).then(() => {
				if(!this._hasListeners()){
					this._stop()
				}
			})

		}else if(this.connected){
			return this.proxy.invoke(event, ...args)

		}else{
			throw new Error('Unable to invoke on a closed connection')
		}
	}

	_hasListeners(){
		return Object.values(this.listeners).length !== 0
	}
}

export default new WS()



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/websocket.js